<template>
    <div class="stripe-component">
        <form id="payment-form">
            <div ref="payment-element">

            </div>

            <button ref="submit" class="tb-table__button tb-table__button--blue tb-table__button--color-blue" @click.prevent="submit">
                Submit
            </button>
        </form>
    </div>
</template>

<script>

/**
 * Upon successful payment, client will be redirected to this.return_url, which is just the invite itself.
 * The redirect url will contain params, including payment_intent.
 */

const stripe_public_key = process.env.VUE_APP_STRIPE_KEY;

import {loadStripe} from '@stripe/stripe-js/pure';
import inviteRepository from "@/repository/invites";

export default {
    name: "Stripe",
    components: {

    },
    props: ['invite'],
    data() {
        return {
            public_key: stripe_public_key,
            stripe: null,
            payment_intent_id: null,
            stripe_options: {
                clientSecret: ''
            },
            elements: null,
            payment_element: null,
            return_url: null,
            error_message: '',
            error_timeout: 10000
        }
    },

    methods: {
        async load_stripe() {
            console.log('id');
            console.log(this.invite.event.client.stripe_user_id);
            if (!this.invite.event.client.stripe_user_id) {
                this.$notify({
                    group: 'main',
                    type: 'error',
                    title: 'Unable To Start Payment Process',
                    text: 'We have been unable to initiate the payment process with Stripe.',
                    duration: 10000
                });

                return;
            }

            this.stripe = await loadStripe(this.public_key, {
                stripeAccount: this.invite.event.client.stripe_user_id
            });
        },

        generate_payment_intent() {

            inviteRepository.createPaymentIntent({
                    invite_uuid: this.invite.uuid
                })
                .then(resp => {
                    this.stripe_options.clientSecret = resp.data.client_secret;
                    this.payment_intent_id = resp.data.intent_id;
                    this.renderPaymentElements();
                }).catch(err => {
                    this.$notify({
                        group: 'main',
                        type: 'error',
                        title: 'Unable To Start Payment Process',
                        text: 'We have been unable to initiate the payment process with Stripe.',
                        duration: 10000
                    });
                });
        },

        async submit(ev) {
            let {error} = await this.stripe.confirmPayment({
                elements: this.elements,
                confirmParams: {
                    return_url: this.return_url
                }
            });

            if (error) {
                console.log('error', error);
                // this.displayErrorMessage(error.message);

                this.$notify({
                    group: 'main',
                    type: 'error',
                    title: 'Payment Unsuccessful',
                    text: 'There has been an error when paying with Stripe.',
                    duration: 10000
                });
            }
        },

        renderPaymentElements() {
            this.elements = this.stripe.elements(this.stripe_options)
            this.payment_element = this.elements.create('payment');
            this.payment_element.mount(this.$refs["payment-element"])
        },

        checkStatus() {

        },
    },

    mounted() {
        this.return_url = process.env.VUE_APP_STRIPE_REDIRECT_BASE + this.invite.uuid;
        this.payment_intent = this.generate_payment_intent();
        this.load_stripe();
    }
}
</script>

<style scoped>

</style>